import { BUDGET_STATUS } from "Config";

export const getBudgetNumberFormat = chiffre => {
  let myNumber = chiffre.toString();
  let number = Math.round(chiffre).toString();
  if (myNumber.includes(".") && number.length < 2) {
    return myNumber;
  } else if (myNumber.includes(".") && number.length > 1) {
    return myNumber;
  } else if (!myNumber.includes(".") && number.length < 2) {
    return myNumber + ".00";
  } else if (!myNumber.includes(".") && number.length > 1) {
    return myNumber + ".00";
  }

  return chiffre;
};

export const getBudgetNumberLabelFormat = number => {
  let myNumber = number.toString();
  let chiffre = Math.round(number).toString();
  if (myNumber.includes(".") && chiffre.length < 2) {
    return "0" + myNumber;
  } else if (myNumber.includes(".") && chiffre.length > 1) {
    return myNumber;
  } else if (!myNumber.includes(".") && chiffre.length < 2) {
    return "0" + myNumber + ",00";
  } else if (!myNumber.includes(".") && chiffre.length > 1) {
    return myNumber + ",00";
  }

  return chiffre;
};

export const roundDecimal = (number, precision) => {
  const prc = precision || 2;
  const tmp = Math.pow(10, prc);
  return Math.round(number * tmp) / tmp;
};

export const roundNumber = num => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const toNumber = value => {
  return value !== "" || Number.isNaN(value) ? parseFloat(value) : 0;
};

export const toFixed = (value, precision) => {
  return Number(value).toFixed(precision);
};

export const getBudgetaryBenchmarkRatio = (revenue, budgetTotal) => {
  return budgetTotal ? roundDecimal(revenue / budgetTotal) : 0.0;
};

export const getBudgetaryBenchmark = budgetaryBenchmarkRatio => {
  return roundDecimal(budgetaryBenchmarkRatio / 0.7);
};

export const getBudgetaryBenchmarkRate = budgetaryBenchmark => {
  const rate = budgetaryBenchmark / 25.0;
  return budgetaryBenchmark ? (rate >= 1.0 ? rate - 1.0 : 0.0) : 0.0;
};

export const generateBudgetStatus = id => {
  switch (id) {
    case "all":
      return [
        BUDGET_STATUS.STATUS_UNAUTHORIZED_BUDGET,
        BUDGET_STATUS.STATUS_GLOBAL_BUDGET_AFFECTED,
        BUDGET_STATUS.STATUS_GLOBAL_BUDGET_NOT_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_BY_ZONE_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_ZONE_DELEGATION_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED,
        BUDGET_STATUS.STATUS_DELEGATION_NOT_AFFECTED,
        BUDGET_STATUS.STATUS_INFORMATIONS_CLIENT_COMPLETED,
        BUDGET_STATUS.STATUS_MANAGEMENT_TASKES_COMPLETED,
        BUDGET_STATUS.STATUS_BUDGET_COMPLETED
      ];
    case "unbudgeted":
      return [BUDGET_STATUS.STATUS_GLOBAL_BUDGET_NOT_AFFECTED];
    case "inProgress":
      return [
        BUDGET_STATUS.STATUS_GLOBAL_BUDGET_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_BY_ZONE_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_ZONE_DELEGATION_AFFECTED,
        BUDGET_STATUS.STATUS_BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED,
        BUDGET_STATUS.STATUS_INFORMATIONS_CLIENT_COMPLETED,
        BUDGET_STATUS.STATUS_MANAGEMENT_TASKES_COMPLETED,
        BUDGET_STATUS.STATUS_DELEGATION_NOT_AFFECTED
      ];
    case "budgeted":
      return [BUDGET_STATUS.STATUS_BUDGET_COMPLETED];
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./src/utils/budget.js